import { createMuiTheme } from '@material-ui/core/styles';
import imageSource from '../skylinelogo.png';
export const logo = {
    imageSource: imageSource,
    style: { height: '200px'},
    altText: 'Skyline Diesel & Towing'
}

export const palette = {
    "root": {
        colorPrimary0: "#0356a6",	/* Main Primary color */
        colorPrimary1: "#428ac9",
        colorPrimary2: "#bcdaf7",	
        colorPrimary3: "#024586",
        colorPrimary4: "#00509b",

        colorSecondary1_0: "#FFD95D",	/* Main Secondary color (1) */
        colorSecondary1_1: "#FFECAE",
        colorSecondary1_2: "#FFE181",
        colorSecondary1_3: "#f8ce55",
        colorSecondary1_4: "#DFAF10",
        
        colorSecondary2_0: "#FF915D",	/* Main Secondary color (2) */
        colorSecondary2_1: "#FFC8AE",
        colorSecondary2_2: "#FFAA81",
        colorSecondary2_3: "#FB7A3B",
        colorSecondary2_4: "#ed2125",
    
        grayText: "rgba(0, 0, 0, 0.5)"
    },
    "common": {
        "black": "rgba(41, 40, 40, 0.87)",
        "white": "#fff",
        "gray": "#eee",
        "darkGray": "#28313d",
        "grayText": "rgba(0, 0, 0, 0.5)",
    },
    "background": {
        "paper": "#fff",
        "default": "#fafafa",
        "dashboard": "#fff"
    },
    "dashboard": {
        "containerLinks": {
            "text": "#fff8e1",
            "background": "#e3562a",
            "border": "#26323d"
        }
    },
    "secondary": {
        "main": "#212121",
        "light": "#484848",
        "dark": "#000000",
        "contrastText": "#fff"
    },
    "primary": {
        "light": "#ff6946",
        "main": "#d1341b",
        "dark": "#980000",
        "contrastText": "#fff8e1"
    },
    "table": {
        "hover": "rgba(255,105, 70, 0.27)",
        "hoverBoxShadow": ""
    },
    "error": {
        "light": "#e57373",
        "main": "#f44336",
        "dark": "#d32f2f",
        "contrastText": "#fff"
    },
    "text": {
        "primary": "rgba(41, 40, 40, 0.87)",
        "secondary": "rgba(0, 0, 0, 0.54)",
        "disabled": "rgba(0, 0, 0, 0.38)",
        "hint": "rgba(0, 0, 0, 0.38)"
    }
};

const theme = createMuiTheme({
    "palette": palette,
    typography: {
        useNextVariants: true,
      },
});

export default theme;